import type { ZudokuConfig } from "zudoku";

const config: ZudokuConfig = {
  site: {
    logo: {
      src: { light: "/logo-light.svg", dark: "/logo-dark.svg" },
      alt: "Seqhub",
      width: "130px",
    },
  },
  navigation: [
    {
      type: "category",
      label: "Documentation",
      items: [
        {
          type: "category",
          label: "Getting Started",
          icon: "sparkles",
          items: [
            "/introduction",
            {
              type: "link",
              icon: "folder-cog",
              badge: {
                label: "New",
                color: "purple",
              },
              label: "API Reference",
              to: "/api",
            },
          ],
        },
      ],
    },
    {
      type: "link",
      to: "/api",
      label: "API Reference",
    },
  ],
  docs: {
    publishMarkdown: true,
    defaultOptions: {
      copyPage: true,
    },
    // For agents and LLM tooling: llms.txt is the index, llms-full.txt the whole corpus in one
    // fetch. See https://llmstxt.org/. Pairs with the raw spec served at /seqhub-public.json
    // (see public/) -- prose for reading, the OpenAPI document for generating calls against.
    llms: {
      llmsTxt: true,
      llmsTxtFull: true,
    },
  },
  redirects: [{ from: "/", to: "/introduction" }],
  apis: [
    {
      type: "file",
      input: "./apis/seqhub-public.json",
      path: "/api",
      expandAllTags: true,
    },
  ],
};

export default config;
